import { Icon } from '@iconify/react';
import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import IconLogo from 'src/assets/white-logo.svg?react';
import { ConnectButton } from 'src/components/Header/ConnectButton';
import { TransactionStatus } from 'src/components/Header/TransactionStatus';
import { DrawerSidebar } from '../LeftSidebar/LeftSidebar.tsx';
import { UIButton } from '../UI/UIButton.tsx';

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <>
      <div className="flex flex-col items-center px-6 py-4 sm:flex-row">
        <div className="flex w-full items-center justify-between sm:w-auto">
          <a href="http://agint.xyz/" target="_blank">
            <IconLogo />
          </a>
          <div className="flex gap-3 sm:hidden">
            <TransactionStatus />
            <button onClick={() => setIsMenuOpen(!isMenuOpen)}>
              <Icon icon="fa6-solid:bars" className="h-6 w-6" />
            </button>
          </div>
        </div>
        {/*<h1 className="ml-8 hidden text-xl sm:block">Artificial General Intelligence</h1>*/}
        <div className="ml-auto hidden items-center space-x-6 sm:flex">
          <TransactionStatus />
          {/*<ConnectTwitter />*/}
          <NavLink to="/bridge">
            <UIButton buttonColor="blue">Bridge</UIButton>
          </NavLink>
          <ConnectButton />
          <button className="lg:hidden" onClick={() => setIsMenuOpen(!isMenuOpen)}>
            <Icon icon="fa6-solid:bars" className="h-6 w-6" />
          </button>
        </div>
      </div>

      <DrawerSidebar isOpen={isMenuOpen} close={() => setIsMenuOpen(false)} />
    </>
  );
};
